import { useState, useCallback, useEffect, useMemo } from 'react';
import useStaticHandler from '../useStaticHandler/useStaticHandler.js';
import useClickOutside from '../useClickOutside/useClickOutside.js';

const SPACE_FROM_LIMIT = 20;

// This functions is used to avoid opening the context menu outside the user screen.
const calculateMenuPosition = (buttonPosition, menuRect) => {
  let finalPosY = buttonPosition.y;
  let finalPosX = buttonPosition.x;
  if (buttonPosition.y + menuRect.height > window.innerHeight) {
    finalPosY = window.innerHeight - menuRect.height - SPACE_FROM_LIMIT;
  }
  if (buttonPosition.x + menuRect.width > window.innerWidth) {
    finalPosX = window.innerWidth - menuRect.width - SPACE_FROM_LIMIT;
  }
  return {
    x: finalPosX,
    y: finalPosY
  };
};
const useContextMenu = contextMenuRef => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const handleClose = useStaticHandler(() => {
    setIsMenuOpen(false);
  });
  useClickOutside(contextMenuRef, handleClose);
  // This function is used to open manually with a button the context menu, it requires the reference.
  // The reference can be a button or any html element, and is used only to know where to position the context menu.
  const handleOpen = useStaticHandler((x, y) => {
    const menuRect = contextMenuRef?.current?.getBoundingClientRect();
    if (menuRect) {
      const openPosition = {
        x,
        y
      };
      const {
        x: finalX,
        y: finalY
      } = calculateMenuPosition(openPosition, menuRect);
      setPosition({
        x: finalX,
        y: finalY
      });
      setIsMenuOpen(true);
    }
  });
  const handleKeyDown = useCallback(event => {
    if (event.key === 'Escape' && isMenuOpen) {
      handleClose();
    }
  }, [isMenuOpen, handleClose]);
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown, contextMenuRef]);
  return useMemo(() => ({
    isOpen: isMenuOpen,
    position,
    handleOpen,
    handleClose
  }), [isMenuOpen, position, handleOpen, handleClose]);
};
var useContextMenu$1 = useContextMenu;

export { useContextMenu$1 as default };
//# sourceMappingURL=useContextMenu.js.map
